/** Marca: anillo dorado con una K, como el favicon. */
export function Logo() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <circle cx="32" cy="32" r="26" fill="none" stroke="#d9b45b" strokeWidth="3" />
      <text x="32" y="43" textAnchor="middle" fontFamily="Georgia, serif" fontSize="30" fill="#f0e3bd">
        K
      </text>
    </svg>
  );
}
